module.exports = "/_next/static/images/Trend05Visual@2x-dc574e85aecfcf17f9141ab29d07a609.webp";